var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 67,
    viewBox: "0 0 54 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5792 30.5717C53.6899 31.9534 53.6899 35.0466 51.5792 36.4283L6.65835 65.835C4.3306 67.3588 1.24137 65.6888 1.24137 62.9067L1.24137 4.09334C1.24137 1.31116 4.33061 -0.358837 6.65836 1.16499L51.5792 30.5717Z",
    stroke: "#DDDDDD",
    strokeOpacity: 0.8,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/playIcon.79be3671f94523916bfed962cbfa1597.svg";
export { ForwardRef as ReactComponent };